import { useState, useEffect, useRef } from 'react';

const PING_URL = 'https://1.1.1.1/cdn-cgi/trace';
const HISTORY_LEN = 30;
const INTERVAL_MS = 2000;

/**
 * Measures latency to the Cesium ION API server.
 *
 * @returns {{ latencyMs: number|null, history: (number|null)[], label: string, color: string }}
 */
export function usePing() {
  const [latencyMs, setLatencyMs] = useState(null);
  const [history, setHistory] = useState(() => Array(HISTORY_LEN).fill(null));
  const timerRef = useRef(null);

  useEffect(() => {
    const measure = async () => {
      try {
        const start = performance.now();
        await fetch(PING_URL, { mode: 'no-cors', cache: 'no-store' });
        const ms = Math.round(performance.now() - start);
        setLatencyMs(ms);
        setHistory(prev => [...prev.slice(1), ms]);
      } catch {
        setLatencyMs(null);
        setHistory(prev => [...prev.slice(1), null]);
      }
    };

    measure();
    timerRef.current = setInterval(measure, INTERVAL_MS);
    return () => clearInterval(timerRef.current);
  }, []);

  // Color thresholds: green < 50ms (excellent), orange < 150ms (ok), red >= 150ms (poor)
  let color = '#fff';
  let label = '---';
  if (latencyMs !== null) {
    if (latencyMs < 50) {
      color = '#4caf50';
    } else if (latencyMs < 150) {
      color = '#ff9800';
    } else {
      color = '#f44336';
    }
    label = `${latencyMs} ms`;
  }

  return { latencyMs, history, label, color };
}
